import { render, staticRenderFns } from "./trainingTemplate.vue?vue&type=template&id=fbba11f4&scoped=true&"
import script from "./trainingTemplate.vue?vue&type=script&lang=js&"
export * from "./trainingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./trainingTemplate.vue?vue&type=style&index=0&id=fbba11f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba11f4",
  null
  
)

export default component.exports